// Utils/renderHelpers.js
import React from 'react'

export const COFFEE_COMMUNITIES_RENDER_HELPERS = {
  UploadSpinner() {
    return (
      <div className="attachment-upload-spinner">
        <i className="pi pi-spin pi-spinner" />
      </div>
    )
  },

  AttachmentIcon({ type, count, attachments }) {
    const attachmentArray = Array.isArray(attachments) ? attachments : []
    const totalCount = typeof count === 'number' ? count : attachmentArray.length

    // Hide the aggregated count when there are multiple attachments
    // and at least one of them has a caption.
    const hasAnyCaption = attachmentArray.some((att) => att.caption && att.caption.trim())
    const shouldHideCount = totalCount > 1 && hasAnyCaption
    const remainingCountText = !shouldHideCount && totalCount > 1 ? ` (+${totalCount - 1})` : ''

    if (type === 'image') {
      return (
        <div>
          <i className="pi pi-camera"></i>
          <p>Photo{remainingCountText}</p>
        </div>
      )
    }

    if (type === 'document') {
      return (
        <div>
          <i className="pi pi-file-pdf"></i>
          <p>Document{remainingCountText}</p>
        </div>
      )
    }

    if (type === 'video') {
      return (
        <div>
          <i className="pi pi-video"></i>
          <p>Video{remainingCountText}</p>
        </div>
      )
    }

    return null
  }
}
